import React from 'react';
import { cn } from '../lib/utils';

interface SectionWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  containerClassName?: string;
}

export const SectionWrapper = React.forwardRef<HTMLDivElement, SectionWrapperProps>(
  ({ className, containerClassName, children, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn('py-16 md:py-24 relative overflow-hidden', className)}
        {...props}
      >
        <div className={cn('container mx-auto px-4 md:px-6 max-w-7xl', containerClassName)}>
          {children}
        </div>
      </section>
    );
  }
);

SectionWrapper.displayName = 'SectionWrapper';
